import React, { PropTypes as T } from 'react';
import { Icon } from 'b3';
import LeftTimelineArrow from '../LeftTimelineArrow';

export default class TimelineItem extends React.Component {
    static defaultProps = {
        openEditModal: null,
        openDeleteModal: null,
        wrapInBubble: true,
        extraInfo: null,
        isLongContent: false,
        isCompleted: false
    };
    static propTypes = {
        type: T.string.isRequired,
        typeLabel: React.PropTypes.oneOfType([T.string, T.element]),
        avatar: T.element, // not required for uncompleted
        icon: T.element.isRequired
    };

    constructor(props){
        super(props);

        this.state = {
            isBubbleExpanded: false,
            bubbleStyle: {height: '150px'},
            showMoreStyle: {top: '120px'},
            isHoverActive: false
        };
    }

    toggleBubble(){
        this.setState({
            isBubbleExpanded: ! this.state.isBubbleExpanded
        });
    }

    onMouseOver() {
        this.setState({ isHoverActive: true });
    }

    onMouseLeave() {
        this.setState( { isHoverActive: false });
    }

    render() {
        var { 
            children, 
            avatar,
            icon, 
            wrapInBubble, 
            type, 
            typeLabel,
            extraInfo,
            openEditModal,
            openDeleteModal,
            isLongContent,
            isCompleted
        } = this.props;

        var {isHoverActive} = this.state;

        // var isLongContent = children ? length > 200 : false;
        var showMoreLabel = this.state.isBubbleExpanded ? 'Show less...' : 'Show more...';
        var bubbleStyle = isLongContent ? (this.state.isBubbleExpanded ? { maxHeight: '9000px' } : { maxHeight: "152px" }) : {};
        var showMoreStyle = isLongContent ? (this.state.isBubbleExpanded ? { width: '125px' } : { width: "100%" }) : {};

        var typeAndCompletedClassname = `${type} ${isCompleted ? 'completed' : 'scheduled'}`;

        return (
            <div className="timelineLineEventLeftArrowWrapper">
                <LeftTimelineArrow className={typeAndCompletedClassname} />
                <div className="clientTimeline__event__container">
                    <div className={`clientTimeline__event__type ${type} ${typeAndCompletedClassname}`}>
                        <div className="clientTimeline__event__type__content">
                            {icon}
                            <p>{typeLabel}</p>
                        </div>
                    </div>

                    <div className="clientTimeline__event__content" onMouseOver={this.onMouseOver.bind(this)} onMouseLeave={this.onMouseLeave.bind(this)}>
                        <div className="clientTimeline__event__content__avatar">
                            {avatar}
                        </div>

                        {wrapInBubble &&
                            <div className="clientTimeline__event__content__arrow"></div>
                        }
                        <div className="clientTimeline__event__content__body">
                            {wrapInBubble &&
                                <div>
                                    <div className="clientTimeline__event__content__body__bubble" style={bubbleStyle}>
                                        {children}
                                        {isLongContent && 
                                            <span className="clientTimeline__event__content__body__bubble__more" onClick={this.toggleBubble.bind(this)} style={showMoreStyle}>
                                                {showMoreLabel}
                                            </span>
                                        }
                                    </div>
                                    {extraInfo && 
                                        <div className="clientTimeline__event__content__body__info">
                                            {extraInfo}
                                        </div>
                                    }
                                </div>
                            }
                            {! wrapInBubble && 
                                <div style={{marginLeft: 10}}>
                                    {children}
                                </div>
                            }
                        </div>

                        {isHoverActive &&
                            <div className="clientTimeline__event__content__buttons">
                                {openDeleteModal && 
                                    <span style={{marginLeft: "10px"}} 
                                        onClick={openDeleteModal.bind(this)} 
                                        className="right-btn pull-right"><Icon icon="cross" /></span>
                                }
                                {openEditModal && 
                                    <span onClick={openEditModal.bind(this, this.props)} 
                                        className="right-btn pull-right"><Icon icon="pencil-2"/></span>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/client-timeline/items/TimelineItem.js